const Menu =  [
    { header: 'master data' },
    {
        path    : '/',
        title   : 'Dashboard',    
        name    : 'dashboard',  
        icon    : 'dashboard', 
        meta    : {breadcrumb:false}
    }, 
    {
      title: 'Master & Area',         
      group: 'adm',
      icon : 'public',        
      items: [                      
          { title : 'Quetionnaire', name: 'quetionnaire'},
          //{ title : 'Questionnaire', name: 'questionnaire'},
          { title : 'Gedung & Ruang', name: 'gedung', meta : {breadcrumb:false}},
          /*{ title : 'Provinsi', name: 'provinsi'},
          { title : 'Kota/Kab', name : 'kota' },
          { title : 'Kecamatan', name: 'kecamatan' },            
          { title : 'Kelurahan', name: 'kelurahan' },*/                                  
      ]
    },
    {
      path    : '/settings',
      title   : 'Settings',    
      name    : 'settings',  
      icon    : 'settings_applications', 
      meta    : {breadcrumb:true}
    },   
    
    //NON MENU
    { group: 'dashboard',
      visible: false,
      items:[
        { title : 'Explore', name: 'explore', meta:{breadcrumbs:false} },
        { title : 'Live', name: 'live', meta:{breadcrumbs:false, public:true} },
      ]
    },   
    { group: 'profile',
      visible: false,
      items:[
        { title : 'Profile', meta:{breadcrumbs:false} },
        { title : 'Update Profile', name: 'form' },        
      ]
    },
    {
      group: 'adm',
      visible : false,
      items: [
          { title : 'Wawancara', name: 'quetionnaire/form'},
          { title : 'Questionnaire', name: 'questionnaire/form'},
          { title : 'Mata Pelajaran', name: 'matpel/form'},
          { title : 'Soal', name: 'quetionnaire/view'},
          /*{ title : 'Provinsi', name: 'provinsi/form'},
          { title : 'Kota/Kab', name: 'kota/form' },
          { title : 'Kecamatan', name: 'kecamatan/form' },            
          { title : 'Kelurahan', name: 'kelurahan/form' }, */           
      ]
    },   
    { group: 'settings',
      visible: false,
      items:[
        { title : 'Setting Form', name: 'form' },        
      ]
    }, 
];

import Remenu from '@/util/remenu';
export default Remenu(Menu);
